const ENDPOINT = 'GETgenres';
function getGenres(gateway, params) {
    return gateway.get(getGenres.endpoint, params);
}
getGenres.endpoint = ENDPOINT;

export { getGenres as default };
//# sourceMappingURL=getGenres.js.map
